// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { IFormRole } from '~/utils/interface/role';
import { EMPTY_STRING } from '~/utils/constants/common';

export const schema = (t: TFunction): yup.ObjectSchema<IFormRole> => {
  return yup.object().shape({
    name: yup
      .string()
      .trim()
      .required(t('common_validate_field_required', { ns: 'common/base' })),
    isMobile: yup.boolean().optional(),
    description: yup.string().trim().optional(),
    codes: yup.array().optional(),
  });
};

export const defaultValues: IFormRole = {
  name: EMPTY_STRING,
  description: EMPTY_STRING,
  isMobile: false,
  codes: [],
};
